/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class LoginService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Logout
     * Logout current session or all sessions
     * @param requestBody
     * @returns any Successfully logged out
     * @throws ApiError
     */
    public logout(
        requestBody?: {
            /**
             * Force to logout all devices
             */
            all?: boolean;
        },
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/logout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                500: `Server error`,
            },
        });
    }
    /**
     * Login with Google
     * Login with a Google ID token. Only works for accounts already linked to the Google identity.
     * @param requestBody
     * @returns any Successfully logged in
     * @throws ApiError
     */
    public googleLogin(
        requestBody: {
            /**
             * Google ID token issued by Google Identity Services
             */
            id_token: string;
        },
    ): Observable<{
        /**
         * User ID
         */
        user_id: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/login/google',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                403: `Forbidden origin`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Login
     * # Login
     * > Download example script [here](/api_request.ts), API flow [here](/api_flow.md)
     * @param requestBody
     * @returns any Successfully logged in
     * @throws ApiError
     */
    public login(
        requestBody: {
            /**
             * Password
             */
            password: string;
            /**
             * Username/email
             */
            username: string;
        },
    ): Observable<{
        /**
         * User ID
         */
        user_id: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/login/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden origin`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
